import React, { useState } from "react";

const MessageModal = ({
  isOpen,
  onConfirm,
  title,
  subtitle,
  btn_text = "Ya, Lanjutkan.",
}) => {
  const [inputValue, setInputValue] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="login-container bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <svg
          className="w-20 h-20 text-yellow-600 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <h3 className="text-xl text-center font-normal text-gray-500 mt-5 mb-2">
          {title}
        </h3>
        <p className="text-sm text-justify mb-2">{subtitle}</p>
        {/* <input
          type="text"
          className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
          placeholder="Ketik Pesan Balasan untuk Pengawas..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        /> */}

        <div className="flex justify-center gap-2">
          <button
            onClick={() => onConfirm(inputValue)} // Pass value to parent
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            {btn_text}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;